import { HorizontalBounds } from '../types';

// clientWidth excludes the vertical scrollbar gutter, so the clip stops before it instead of across it.
export const getScrollViewportBounds = (
  viewport: Element
): HorizontalBounds => {
  const rect: DOMRect = viewport.getBoundingClientRect();
  const left: number = rect.left + viewport.clientLeft;

  return { left, right: left + viewport.clientWidth };
};
